export default __webpack_public_path__ + "static/media/portfolio-97.531755ef.jpg";